import { createSelector, createSlice } from '@reduxjs/toolkit';
import { attributeModelDropDownRoutes } from './attributeModelRoutes';
import { clearSites, selectSite } from 'features/topbar/selectedSiteSlice';

import { AttributionModelTypes } from 'common/constants/attribution-model-types';
import { RootState } from 'app/store';
import { setSelectedDropDownItemAsActive } from 'common/components/drop-downs/legacy/dropDownUtils';
import { PURGE } from 'redux-persist';
import { togglePoc } from 'features/poc/poc-toggle/pocToggleSlice';

const initialState = {
  availableAttributionModels: attributeModelDropDownRoutes
};
const defaultAttribution = 'FirstClickAttributionModel';

const availableAttributionModelsSlice = createSlice({
  name: 'availableAttributionModels',
  initialState,
  reducers: {
    selectAttributionModel: (state, { payload }) => {
      state.availableAttributionModels = setSelectedDropDownItemAsActive(
        state.availableAttributionModels,
        payload
      );
    },
    enableImpressionsAttributionModelDefault: (state) => {
      if (
        state.availableAttributionModels.find(
          (model) => model.key === AttributionModelTypes.Impressions
        )
      ) {
        return;
      }

      state.availableAttributionModels = [
        ...state.availableAttributionModels,
        {
          key: AttributionModelTypes.Impressions,
          label: 'DDA & Impressions',
          isActive: false
        }
      ];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(clearSites, (state) => {
      state.availableAttributionModels = attributeModelDropDownRoutes;
    });
    builder.addCase(selectSite, (state) => {
      state.availableAttributionModels = attributeModelDropDownRoutes;
    });
    builder.addCase(PURGE, () => initialState);
    builder.addCase(togglePoc, (state) => {
      state.availableAttributionModels =
        state.availableAttributionModels.filter(
          (attributeModelRoute) =>
            attributeModelRoute.key !== AttributionModelTypes.DataDriven
        );

      if (
        !state.availableAttributionModels.find(
          (attributeModelRoute) =>
            attributeModelRoute.key === AttributionModelTypes.Impressions
        )
      ) {
        enableImpressionsAttributionModelDefault();
      }
    });
  }
});

const selectAttributionModelsWithPocState = (
  state: RootState,
  pocEnabled: boolean
) => {
  return state.availableAttributionModels.availableAttributionModels.filter(
    (model) => !model.pocOnly || pocEnabled
  );
};

export const getAvailableAttributionModels = createSelector(
  selectAttributionModelsWithPocState,
  (attributionModels) => {
    return attributionModels;
  }
);

export const getSelectedAttributionModel = createSelector(
  selectAttributionModelsWithPocState,
  (attributionModels) =>
    attributionModels.find((model) => model.isActive)?.key ?? defaultAttribution
);

export const { actions, reducer } = availableAttributionModelsSlice;

export const {
  selectAttributionModel,
  enableImpressionsAttributionModelDefault
} = actions;

export default reducer;
